import styles from "./BlogLoadingState.module.css";

export default function BlogLoadingState({
  title = "Loading content",
  message = "Please wait while we prepare the latest blog content.",
  fullScreen = false,
}) {
  return (
    <div className={`${styles.shell} ${fullScreen ? styles.fullScreen : ""}`.trim()}>
      <div className={styles.card}>
        <div className={styles.spinner} />
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
    </div>
  );
}
